export const vhmHeaderClasses = 'flex items-center justify-between py-4 px-5 border-b border-border-light';

export const vhmHeaderTitleClasses = 'text-lg font-semibold text-content font-sans';

export const vhmBodyClasses = 'flex h-[calc(85vh-58px)] overflow-hidden';

export const vhmColumnClasses = 'w-55 min-w-55 overflow-y-auto py-2';

export const vhmColumnBorderLeftClasses = 'border-l border-border-light';

const vhmLabelBaseClasses = 'text-[calc(var(--spacing)*2.75)] font-bold text-subtle uppercase tracking-wider px-3.5';

export const vhmColumnLabelClasses = `${vhmLabelBaseClasses} pt-1 pb-2`;

export const vhmSeparatorClasses = `${vhmLabelBaseClasses} pt-3 pb-1`;

const vhmRowBaseClasses = 'py-2 px-3.5 cursor-pointer text-[calc(var(--spacing)*3.25)] text-content rounded my-px mx-1.5 hover:bg-primary-surface';

export const vhmFileItemClasses = `${vhmRowBaseClasses} flex items-center justify-between`;

export const vhmFileItemActiveClasses = 'bg-primary! text-white! hover:bg-primary-hover!';

export const vhmVersionItemClasses = vhmRowBaseClasses;

export const vhmEmptyMsgClasses = 'py-3 px-3.5 text-[calc(var(--spacing)*3.25)] text-subtle';

export const vhmPlaceholderClasses = 'flex-1 flex items-center justify-center text-[calc(var(--spacing)*3.25)] text-subtle w-auto';

export const vhmChevronClasses = 'text-[calc(var(--spacing)*2.5)] opacity-60';
